import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n/i18n";
import store from "./store/store";
import moment from 'moment-timezone'
import mixins from "./mixins/mixin";

const app = createApp(App);

moment.tz.setDefault("America/New_York");

import $ from "expose-loader?exposes=$,jQuery!jquery";

import VAInput from "@/components/theme/VAInput";
import VAButton from "@/components/theme/VAButton";
import Row from "@/components/theme/row";
import Column from "@/components/theme/column";
app.component("row", Row);
app.component("column", Column);
app.component("va-button", VAButton);
app.component("va-input", VAInput);

// VeeValidate
import { defineRule } from 'vee-validate';
import { required, email, min, confirmed, length, numeric } from '@vee-validate/rules';

defineRule('required', required);
defineRule('email', email);
defineRule('min', min);
defineRule('confirmed', confirmed);
defineRule('length', length);
defineRule('numeric', numeric);

// Special rule for email or phone required
defineRule('required_unless', (value, [target, target_value]) => {
  if (!value && !target_value) {
    return false;
  }

  return true;
});

// Vue Modal
// Disable this for now because it's not compatible with Vue 3
//import VModal from "vue-js-modal";
//Vue.use(VModal);

// SweetAlert
import VueSweetalert2 from "vue-sweetalert2";
import 'sweetalert2/dist/sweetalert2.min.css';
app.use(VueSweetalert2);

// Vue Multiple Select
import Multiselect from "vue-multiselect";
app.component("multiselect", Multiselect);

// Vue Toggle switch
import ToggleButton from "@/components/theme/ToggleButton";
app.component("toggle-button", ToggleButton);

// Vue Awesome Paginate
import VueAwesomePaginate from "vue-awesome-paginate";
import "vue-awesome-paginate/dist/style.css";
app.use(VueAwesomePaginate);

// local storage to Vuex Store
import local_storage_service from "@/services/utilities/local-storage";
local_storage_service.setItemsInStore();

// Vue gtag for google analytics
import VueGtag from "vue-gtag";
if(process.env.MIX_APP_ENV == 'production'){
  app.use(VueGtag, {
    config: { id: process.env.MIX_GOOGLE_ANALYTICS_ID }
  });
}

app.mixin(mixins);
app.use(store);
app.use(i18n);
app.use(router);
app.mount("#app");
